import React from 'react'
import { Loading, format } from '../twd'

export default ({rows, status, count, onLoadMore, pageSize=10} = {}) => {
    const moreCount = Math.min(pageSize, count - rows.length)

    return <Loading status={status}>
    { rows.length ? (
        <div className="row">
        <div className="col-xs-12 col-sm-3">Viewing 1 - {format.count(rows.length)} of {format.count(count)}</div>
        { moreCount > 0 ? (
            <div className="col-xs-12 col-sm-6">
                <button
                    data-name="offerings-view-more"
                    onClick={onLoadMore}
                    className="btn btn-primary btn-block"
                >View {format.count(moreCount)} more</button>
            </div>
        ) : null}
        </div>
    ) : (
        <div className="universal-message universal-message-danger">
        <div className="universal-message-content">
        <p className="universal-message-heading">
            No result found.
        </p>
        </div>
        </div>
    )}
    </Loading>
}



// WEBPACK FOOTER //
// ./src/offerings/view-more.js